import { render, staticRenderFns } from "./purchasePaymentDetail.vue?vue&type=template&id=dd109dec&scoped=true&"
import script from "./purchasePaymentDetail.vue?vue&type=script&lang=js&"
export * from "./purchasePaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchasePaymentDetail.vue?vue&type=style&index=0&id=dd109dec&lang=scss&scoped=true&"
import style1 from "./purchasePaymentDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd109dec",
  null
  
)

export default component.exports